if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.atcButton = this.querySelector('.js-atc-button');
      this.productFormAtcButton = this.productForm.querySelector('.js-add-to-cart');

      if (this.productFormAtcButton) {
        this.productFormAtcButton.setAttribute('data-connected-button', '.js-atc-button');
      }

      this.bottomOffsetSelectors = [
        '#cart-notification.cart-notification-wrapper.active',
        '.cart-notification-wrapper.active',
        '.quick-cart.active',
        '.quick-cart.is-visible'
      ];

      this.bindEvents();
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      window.removeEventListener('resize', this.resizeHandler);
      document.removeEventListener('on:cart:add', this.refreshOffsetHandler);
      document.removeEventListener('on:cart-drawer:after-open', this.refreshOffsetHandler);
      document.removeEventListener('on:cart-drawer:after-close', this.refreshOffsetHandler);

      if (this.bottomOffsetObserver) this.bottomOffsetObserver.disconnect();
      this.atcButton.removeEventListener('click', this.atcClickHandler);
    }

    bindEvents() {
      if (this.hasAttribute('data-show-on-scroll')) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === this.productForm && !theme.mediaMatches.md) {
              this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
            } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
              this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
            }
          });
        });

        if (this.productForm) observer.observe(this.productForm);
        if (this.productInfo) observer.observe(this.productInfo);

        window.addEventListener('scroll', StickyAtcPanel.handleScroll);
      }

      this.atcClickHandler = this.atcClickHandler || this.handleAtcClick.bind(this);
      this.atcButton.addEventListener('click', this.atcClickHandler);

      this.refreshOffsetHandler = this.refreshOffsetHandler || this.updateBottomOffset.bind(this);
      this.resizeHandler = this.resizeHandler || this.updateBottomOffset.bind(this);

      window.addEventListener('resize', this.resizeHandler);
      document.addEventListener('on:cart:add', this.refreshOffsetHandler);
      document.addEventListener('on:cart-drawer:after-open', this.refreshOffsetHandler);
      document.addEventListener('on:cart-drawer:after-close', this.refreshOffsetHandler);

      this.bottomOffsetObserver = new MutationObserver(() => this.updateBottomOffset());
      this.bottomOffsetObserver.observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style', 'open', 'aria-hidden']
      });
      this.updateBottomOffset();

      // Grab the currently selected swatch
      const stickyAtcVariantSwatch = this.querySelector('.js-atc-selected-variant-swatch');
      const activeSwatch = document.querySelector('.product-main .opt-btn:checked + .opt-label--swatch');
      if (stickyAtcVariantSwatch && activeSwatch) {
        stickyAtcVariantSwatch.innerHTML = activeSwatch.outerHTML;
      }
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }

    /**
     * Handle the click of the atc button
     */
    handleAtcClick() {
      if (this.productFormAtcButton) this.productFormAtcButton.click();
    }

    updateBottomOffset() {
      let maxOffset = 0;

      this.bottomOffsetSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          if (!el || !el.getBoundingClientRect) return;

          const styles = window.getComputedStyle(el);
          if (styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) === 0) return;

          const rect = el.getBoundingClientRect();
          if (rect.height <= 0 || rect.width <= 0 || rect.top >= window.innerHeight) return;

          const overlap = Math.max(0, window.innerHeight - rect.top);
          maxOffset = Math.max(maxOffset, overlap + 12);
        });
      });

      this.style.setProperty('--sticky-atc-offset', `${Math.round(maxOffset)}px`);
    }

    /**
     * Handle use as part of video testimonials
     */
    videoTestimonialsOpened() {
      this.classList.add('sticky-atc-panel--force-show');
      this.videoTestimonialsVariantClickHandler = () => {
        document.querySelector('video-testimonials[open]').close();
      };
      this.querySelector('a[href="#variants"]').addEventListener('click', this.videoTestimonialsVariantClickHandler);
    }

    /**
     * Reset to normal visibility
     */
    videoTestimonialsClosed() {
      this.classList.remove('sticky-atc-panel--force-show');
      this.querySelector('a[href="#variants"]').removeEventListener('click', this.videoTestimonialsVariantClickHandler);
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
